import {BoxProps, Center, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';
import {CaptainIcon, ViceCaptainIcon} from '../lineup/icons';

interface LeadershipStatusIndicatorProps extends BoxProps {
  status: 'captain' | 'vice-captain';
}

export const CaptainIndicator = ({status, ...props}: LeadershipStatusIndicatorProps) => {
  const t = useTranslate();

  const bgColor = status === 'captain' ? 'gold' : 'silver';

  return (
    <Popover trigger="click">
      <PopoverTrigger>
        <Center
          aria-label={t(`fantasy.lineup.${status}`)}
          width="50%"
          pos="absolute"
          top="-5%"
          insetInlineStart="-25%"
          shadow="md"
          color="white"
          cursor="pointer"
          onClick={(e) => e.stopPropagation()}
          {...props}
        >
          {status === 'captain' ? (
            <CaptainIcon width="full" height="auto" />
          ) : (
            <ViceCaptainIcon width="full" height="auto" />
          )}
        </Center>
      </PopoverTrigger>

      <PopoverContent bg={bgColor} w="fit-content" borderColor={bgColor} _focus={{}}>
        <PopoverArrow bg={bgColor} />

        <PopoverBody textTransform="capitalize" fontSize="xs" fontWeight="700" color="gray.800">
          {t(`fantasy.lineup.${status}`)}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
